import { Theme } from "./types/theme";

/** Brand primary / “mtb-green” — modal CTAs (Save, Next), links, accents (design reference #00BFA5) */
export const MTB_PRIMARY_GREEN = "#00BFA5";

const Button = {
  variants: {
    solid: {
      bg: MTB_PRIMARY_GREEN,
      color: "#FFF",
      borderRadius: "xl",
      // shadow: "0 .125rem .25rem rgb(7 186 160 / 70%)",
      _hover: {
        bg: MTB_PRIMARY_GREEN,
        color: "white",
        _disabled: { bg: MTB_PRIMARY_GREEN },
      },
      _active: { bg: MTB_PRIMARY_GREEN, color: "white" },
      padding: "16px 40px",
      height: "34px",
    },
    outline: {
      color: MTB_PRIMARY_GREEN,
      border: "1.5px solid",
      borderRadius: "12px",
      padding: "16px 40px",
      height: "34px",
    },
    // outline: {
    //   color: "#07BAA0",
    //   borderColor: "#07BAA0",
    //   borderRadius: "xl",
    //   _hover: { bg: "#FFF" },
    // },
    link: {
      color: MTB_PRIMARY_GREEN,
    },
  },
};
const FormLabel = {
  baseStyle: {
    color: "#556075",
  },
};

const Checkbox = {
  baseStyle: {
    control: {
      _checked: {
        bg: MTB_PRIMARY_GREEN,
        borderColor: MTB_PRIMARY_GREEN,
      },
    },
  },
};

export const breakpoints = {
  sm: "320px",
  md: "576px",
  lg: "768px",
  xl: "992px",
  "2xl": "1200px",
  "3xl": "1850px",
} as const;

export const overrides = {
  fonts: {
    body: `'DM Sans Variable', sans-serif`,
    heading: `'DM Sans Variable', sans-serif`,
  },
  styles: {
    global: {
      body: {
        lineHeight: 1.3,
      },
    },
  },
};

export const defaultMTBTheme: Theme = {
  name: "default",
  colors: {
    primary: MTB_PRIMARY_GREEN,
    secondary: "#36425B",
    backgrounds: {
      primary: "#fff",
      secondary: "#fbfcfd",
      terciary: "#E5E7EA",
      quaternary: "#ffffff80",
      error: "#f1cdcd",
    },
    text: {
      primary: "#13161D", // used for most text
      secondary: "#ADB2BC", // used for text which is lower in the visual hierarchy
      tertiary: "#E5E7EA",
      quaternary: "#afb4bd",
      onPrimary: "#FFF",
      onSecondary: "#FFF",
      onTerciary: "#b8b9c1",
      onError: "#ba0808",
    },
    borders: {
      veryLight: "rgb(255 255 255 / 20%)",
      light: "#eff1f5",
      strong: "#000",
    },
  },
  shadows: {
    // card: "0 .125rem .25rem rgba(0,0,0,.075)",
    card: "0 .5rem 1rem rgba(0,0,0,.1)",
    primaryButton: "0 .125rem .25rem rgb(0 191 165 / 70%)",
  },
  components: {
    Button: Button,
    FormLabel: FormLabel,
    Checkbox: Checkbox,
  },
};
